export const initialAssumptions = {
  apr: 0.065,
  loanTerm: 360,
  taxRate: 0.008,
  basePrice: 0,
  insuranceRate: 0.00532,
};
